import React from "react";
import { HeroSection } from "../components/HeroSection";
import { AboutPreview } from "../components/AboutSection";
import { ServicesSection } from "../components/ServicesSection";
import { VehicleFleet } from "../components/VehicleFleet";
import { StatsSection } from "../components/StatsSection";
import { BenefitsSection } from "../components/BenefitsSection";

export const HomePage: React.FC = () => {
  return (
    <div className="pt-16">
      <HeroSection />
      <AboutPreview />
      <ServicesSection />
      <VehicleFleet />
      <StatsSection />
      <BenefitsSection />
    </div>
  );
};
